import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TplQuestionsNpsComponent } from './tpl-questions-nps/tpl-questions-nps.component';
import { TplFeedbackComponent } from './tpl-feedback/tpl-feedback.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TplButtonRedirectComponent } from './tpl-button-redirect/tpl-button-redirect.component';
import { TplOneToFiveScaleComponent } from './tpl-one-to-five-scale/tpl-one-to-five-scale.component';
import { TplFiveStarsComponent } from './tpl-five-stars/tpl-five-stars.component';
import { TplYesOrNotComponent } from './tpl-yes-or-not/tpl-yes-or-not.component';
import { TplInfoComponent } from './tpl-info/tpl-info.component';
import { TplCheckboxesComponent } from './tpl-checkboxes/tpl-checkboxes.component';
import { TplRadiolistComponent } from './tpl-radiolist/tpl-radiolist.component';
import { TplSmilesComponent } from './tpl-smiles/tpl-smiles.component';
 
@NgModule({
  declarations: [
    TplQuestionsNpsComponent,
    TplFeedbackComponent,
    TplButtonRedirectComponent,
    TplOneToFiveScaleComponent,
    TplFiveStarsComponent,
    TplYesOrNotComponent,
    TplInfoComponent,
    TplCheckboxesComponent,
    TplRadiolistComponent,
    TplSmilesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    TplQuestionsNpsComponent,
    TplFeedbackComponent,
    TplButtonRedirectComponent,
    TplOneToFiveScaleComponent,
    TplFiveStarsComponent,   
    TplInfoComponent,
    TplYesOrNotComponent,
    TplCheckboxesComponent,
    TplRadiolistComponent,
    TplSmilesComponent,
  ]
})
export class QuestionsModule { }
